import request from '@/utils/request';

/**
 * 公共接口
 */
export const Common = {
  // 获取广告角标
  getCornerMark: (params) => {
    return request.get(`/ads/adsCornerMark/getCornerMark`, { params });
  },
  // 获取asin的listing信息
  adsListingInfo: (params) => {
    return request.post(`/ads/adsListing/info`, params);
  },
};

/**
 * 广告组合
 */
export const Portfolios = {
  // 广告组合-创建接口
  setPortfolios(params) {
    return request.post(`/ads/portfolios`, params);
  },
  // 广告组合-查询接口
  getPortfolios(params) {
    return request.get(`/ads/portfolios`, { params });
  },
  // 广告组合-判断是否已存在接口
  existsByName(params) {
    return request.get(`/ads/portfolios/existsByName`, { params });
  },
};

/**
 * 广告日志
 */
export const Log = {
  // 操作日志-分页查询接口
  operatingPage(params) {
    return request.post(`/ads/log/operating/page`, params);
  },
};

/**
 * 商品广告
 */
export const SP = {
  // 广告组-根据id获取广告组信息接口
  getCampaignDetails: ({ marketId, campaignId }) => {
    return request.get(`/ads/sp/campaigns/${marketId}/${campaignId}`);
  },
  // 广告组-根据id获取广告组信息接口
  getGroupDetails: ({ marketId, groupId }) => {
    return request.get(`/ads/sp/groups/${marketId}/${groupId}`);
  },
  // 广告活动-判断名称已存在
  existByName: (params) => {
    return request.get(`/ads/sp/campaigns/existByName`, { params });
  },
  // 设为否定商品投放
  bathInsert(params) {
    return request.post(
      `/ads/adsSpNegativeProductTargeting/bathInsert`,
      params
    );
  },
  // 设为否定关键词
  batchAddSpAdGroupNegKeyword(params) {
    return request.post(`/ads/adsSpNegativeKeywords/bath`, params);
  },
  // 设为关键词
  batchAddSpAdKeyword(params) {
    return request.post(`/ads/adsSpKeywords/bath`, params);
  },
  // 【用户搜索词】-设为商品投放
  saveTargetsBySearchKeywords: (params) => {
    return request.post(
      `/ads/adsSpProductTargeting/saveTargetsBySearchKeywords`,
      params
    );
  },
  // 下拉列表-商品广告广告活动
  selectSpCampaigns: (params) => {
    return request.post(`/ads/select/sp/campaigns`, params);
  },
  // 下拉列表-商品广告广告组
  selectSpGroups: (params) => {
    return request.post(`/ads/select/sp/groups`, params);
  },
  // 广告活动-创建接口
  campaignsAdd: (params) => {
    return request.post(`/ads/sp/campaigns`, params);
  },
  // 广告活动-修改接口
  campaignsEdit: (params) => {
    return request.put(`/ads/sp/campaigns`, params);
  },
  // 广告活动-移除广告组合
  setPortfoliosNull: (params) => {
    return request.put(`/ads/sp/campaigns/setPortfoliosNull`, params);
  },
  // 广告活动-删除结束时间
  setEndDateNull: (params) => {
    return request.put(`/ads/sp/campaigns/setEndDateNull`, params);
  },
  // 广告活动-分页查询
  campaignsPage: (params) => {
    return request.post(`/ads/sp/campaigns/page`, params).then((res)=>{
      return Promise.resolve(res.data)
    });
  },
    // 广告活动-获取广告活动建议预算和流量损失预测
    budgetRecommendation: (params) => {
      return request.post(`/ads/suggest/sp/campaign/budgetRecommendation`, params).then((res)=>{
        return Promise.resolve(res.data)
      });
    },
    // 预算分析日志查询（汇总）
    outOfBudgetSummaryAnalysis: (params) => {
        return request.get(`/ads/sp/campaigns/outOfBudgetSummaryAnalysis`,{params});
    },
    // 预算分析日志查询（明细）
    outOfBudgetDetailAnalysis: (params) => {
        return request.get(`/ads/sp/campaigns/outOfBudgetDetailAnalysis`,{params});
    },

  // 新建广告活动、广告组、商品投放 -- 获取商品投放建议竞价
  bidRecommendation: (params) => {
    return request.post(`/ads/suggest/sp/targets/bidRecommendation`, params);
  },
  // 广告位-查询接口
  placementPage: (params) => {
    return request.get(`/ads/sp/campaigns/placement`, { params });
  },
  // 广告位-修改接口
  placementEdit: (params) => {
    return request.put(`/ads/sp/campaigns/placement`, params);
  },
  // 广告活动-判断名称已存在
  existByNameGroup: (params) => {
    return request.get(`/ads/sp/groups/existByName`, { params });
  },
  // 广告组-创建接口
  groupsAdd: (params) => {
    return request.post(`/ads/sp/groups`, params);
  },
  // 广告组-修改接口
  groupsEdit: (params) => {
    return request.put(`/ads/sp/groups`, params);
  },
  // 广告组-分页查询
  groupsPage: (params) => {
    return request.post(`/ads/sp/groups/page`, params);
  },
  // 商品-创建接口
  productAdd: (params) => {
    return request.post(`/ads/sp/product`, params);
  },
  // 商品-修改接口
  productEdit: (params) => {
    return request.put(`/ads/sp/product`, params);
  },
  // 商品-分页查询接口
  productPage: (params) => {
    return request.post(`/ads/sp/product/page`, params);
  },
  // 关键词-创建接口
  keywordsAdd: (params) => {
    return request.post(`/ads/sp/keywords`, params);
  },
  // 关键词-修改接口
  keywordsEdit: (params) => {
    return request.put(`/ads/sp/keywords`, params);
  },
  // 关键词-分页查询接口
  keywordsPage: (params) => {
    return request.post(`/ads/sp/keywords/page`, params);
  },
  // 否定关键词-创建接口
  negativeKeywordsAdd: (params) => {
    return request.post(`/ads/sp/negativeKeywords`, params);
  },
  // 否定关键词-修改接口
  negativeKeywordsEdit: (params) => {
    return request.put(`/ads/sp/negativeKeywords`, params);
  },
  // 否定关键词-分页查询接口
  negativeKeywordsPage: (params) => {
    return request.post(`/ads/sp/negativeKeywords/page`, params);
  },
  // 广告活动否定关键词-创建接口
  campaignNegativeKeywordsAdd: (params) => {
    return request.post(`/ads/sp/campaignNegativeKeywords`, params);
  },
  // 广告活动否定关键词-修改接口
  campaignNegativeKeywordsEdit: (params) => {
    return request.put(`/ads/sp/campaignNegativeKeywords`, params);
  },
  // 广告活动否定关键词-分页查询接口
  campaignNegativeKeywordsPage: (params) => {
    return request.post(`/ads/sp/campaignNegativeKeywords/page`, params);
  },
  // 商品投放-创建接口
  targetsAdd: (params) => {
    return request.post(`/ads/sp/targets`, params);
  },
  // 商品投放-修改接口
  targetsEdit: (params) => {
    return request.put(`/ads/sp/targets`, params);
  },
  // 商品投放-分页查询接口
  targetsPage: (params) => {
    return request.post(`/ads/sp/targets/page`, params);
  },
  // 否定商品投放-创建接口
  negativeTargetsAdd: (params) => {
    return request.post(`/ads/sp/negativeTargets`, params);
  },
  // 否定商品投放-修改接口
  negativeTargetsEdit: (params) => {
    return request.put(`/ads/sp/negativeTargets`, params);
  },
  // 否定商品投放-分页查询接口
  negativeTargetsPage: (params) => {
    return request.post(`/ads/sp/negativeTargets/page`, params);
  },
  // 用户搜索词-分页查询接口
  searchKeywordsPage: (params) => {
    return request.post(`/ads/sp/searchKeywords/page`, params);
  },
};

/**
 * 品牌广告
 */
export const SB = {
  // 下拉列表-品牌广告广告活动
  selectSbCampaigns: (params) => {
    return request.post(`/ads/select/sb/campaigns`, params);
  },
  // 用户搜索词-分页查询
  adsSbSearchKeywordsPage: (params) => {
    return request.post(`/ads/adsSbSearchKeywords/page`, params);
  },
  // 用户搜索词-设为关键词
  saveKeywordsBySearchKeywords: (params) => {
    return request.post(
      `/ads/adsSbKeywords/saveKeywordsBySearchKeywords`,
      params
    );
  },
  // 用户搜索词-设为否定关键词
  saveNegativeKeywordsBySearchKeywords: (params) => {
    return request.post(
      `/ads/adsSbNegativeKeywords/saveNegativeKeywordsBySearchKeywords`,
      params
    );
  },
};

/**
 * 展示广告
 */
export const SD = {
  // 下拉列表-展示广告活动
  selectSdCampaigns(params) {
    return request.post(`/ads/select/sd/campaigns`, params);
  },

  // 下拉列表-展示广告组
  selectSdGroups(params) {
    return request.post(`/ads/select/sd/groups`, params);
  },
};

/**
 * 关键词排名
 */
export const keywordRank = {
  // 关键词排名获取最新更新时间
  lastUpdateTime() {
    return request.get(`/ads/keywordRank/lastUpdateTime`);
  },
  // 关键词排名日志分页查询接口
  keywordRankLogPage(params) {
    return request.post(`/ads/keywordRank/log/page`, params);
  },
  // 关键词排名ASIN校验接口
  checkAsin(params) {
    return request.get(`/ads/keywordRank/checkAsin`, { params });
  },
  // 关键词排名-组查询接口
  getAdsRankGroupList(params) {
    return request.get('/ads/keywordRank/queryAdsLocationGroup', { params });
  },
};

export function addPortfolios(data) {
  return request.post('/ads/adsPortfolios', data).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function getAdProductTargetBrand(params) {
  return request
    .post('/ads/adsSpProductTargeting/getProductTargetingBrands', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

/** 获取站点名牌 */

export function getProductBrands(params) {
  return request
    .get('/ads/adsSbTargeting/getProductBrands', { params })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

/** 获取建议分类 */
export function getAdProductTargetCategories(params) {
  return request
    .post('/ads/adsSpProductTargeting/getProductTargetingCategories', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

/** 商品广告 -- 获取建议分类 */
export function categoryRecommendation(params) {
  return request
    .post('/ads/suggest/sp/targets/categoryRecommendation', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

/**
 * 商品广告
 */

export function getSpAdCampaignPage(params) {
  return request.post('/ads/adsSpCampaigns/page', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function getSpAdCampaign(params) {
  return request.post('/ads/adsSpCampaigns/page', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function getSpAdCampaignList(params) {
  return request
    .get('/ads/adsSpCampaigns/getCampaignList', { params })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function updateSpAdCampaign(params) {
  return request
    .put('/ads/adsSpCampaigns/updateAdsSpCampaigns', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function updateSpAdGroup(params) {
  return request
    .put('/ads/adsSpGroups/updateAdsSpGroups', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getSpAdProductPage(params) {
  return request.post('/ads/adsSpProduct/page', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function getSpAdPlacement(params) {
  return request
    .get('/ads/adsSpCampaigns/getAdsSpCampaignsPlacement', { params })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function updateSpAdProduct(params) {
  return request
    .put('/ads/adsSpProduct/updateAdsSpProduct', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function addSpAdProduct(params) {
  return request.post('/ads/adsSpProduct', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function getListingPage(params) {
  return request.post('/ads/adsListing/page', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

// 新建广告活动、广告组、商品：商品----搜索、输入----tab菜单列表
export function getItemsPage(params) {
  return request.post('/ads/product/metadata/page', params).then((res) => {
    return Promise.resolve(res.data);
  });
}
// 新建广告活动、广告组、商品；商品-搜索-tab菜单列表---可用状态、不符合条件状态、原因
export function eligibility(params) {
  return request
    .post('/ads/product/metadata/eligibility', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

/** 商品关键词 */

//根据关键词获取 关键词 的 翻译
export function getKeywordsInterpret(params) {
  return request.post('/ads/localize/keywords', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function getSpAdKeywordPage(params) {
  return request.post('/ads/adsSpKeywords/page', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function updateSpAdKeyword(params) {
  return request
    .put('/ads/adsSpKeywords/updateAdsSpKeywords', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function updateSpAdKeywordNew(params) {
  return request
    .put('/ads/adsSpKeywords/updateAdsSpKeywordsNew', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function addSpAdKeyword(params) {
  return request.post('/ads/adsSpKeywords', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function getSpAdSuggestKeywordForGroup(params) {
  return request
    .get('/ads/adsSpKeywords/getSuggestedKeywordsForGroupId', { params })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getSpAdSuggestKeywordForAsinList(params) {
  return request
    .post('/ads/adsSpKeywords/getSuggestedKeywordsForAsinList', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getSpAdCampaignNegKeywordPage(params) {
  return request
    .post('/ads/adsSpCampaignNegativeKeywords/page', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function updateSpAdCampaignNegKeyword(params) {
  return request
    .put(
      '/ads/adsSpCampaignNegativeKeywords/updateAdsSpCampaignNegativeKeywords',
      params
    )
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function addSpAdCampaignNegKeyword(params) {
  return request
    .post('/ads/adsSpCampaignNegativeKeywords', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getSpAdGroupNegKeywordPage(params) {
  return request.post('/ads/adsSpNegativeKeywords/page', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function updateSpAdGroupNegKeyword(params) {
  return request
    .put('/ads/adsSpNegativeKeywords/updateAdsSpNegativeKeywords', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function addSpAdGroupNegKeyword(params) {
  return request.post('/ads/adsSpNegativeKeywords', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

/** 商品投放 */

export function getSpAdProductTargetPage(params) {
  return request.post('/ads/adsSpProductTargeting/page', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

// 获取商品投放建议asin --商品、主题
export function productRecommendation(params) {
  return request
    .post('/ads/suggest/sp/targets/productRecommendation', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getSpAdProductTargetProduct(params) {
  return request
    .post('/ads/adsSpProductTargeting/getProductRecommendations', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function updateSpAdProductTarget(params) {
  return request
    .put('/ads/adsSpProductTargeting/updateAdsSpProductTargeting', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function updateSpAdProductTargetNew(params) {
  return request
    .put('/ads/adsSpProductTargeting/updateAdsSpProductTargetingNew', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

/** 否定商品投放 */

export function getSpAdNegTargetPage(params) {
  return request
    .post('/ads/adsSpNegativeProductTargeting/page', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function updateSpAdNegTarget(params) {
  return request
    .put(
      '/ads/adsSpNegativeProductTargeting/updateAdsSpNegativeProductTargeting',
      params
    )
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function addSpAdNegTarget(params) {
  return request
    .post('/ads/adsSpNegativeProductTargeting', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getSpAdTargetGroupPage(params) {
  return request.post('/ads/adsSpProductTargeting/page', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function updateSpAdTargetGroup(params) {
  return request
    .post('/ads/adsSpNegativeProductTargeting/page', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getSpAdSearchWordPage(params) {
  return request
    .post('/ads/adsSpSearchKeywordsReport/page', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

/** 品牌广告 */

export function getSbAdCampaignPage(params) {
  return request.post('/ads/adsSbCampaigns/page', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function updateSbAdCampaign(params) {
  return request
    .post('/ads/adsSbCampaigns/updateAdsSbCampaigns', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

/** 关键词 */

export function getSbAdKeywordPage(params) {
  return request.post('/ads/adsSbKeywords/page', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function updateSbAdKeyword(params) {
  return request
    .post('/ads/adsSbKeywords/updateAdsSbKeywords', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getSbAdNegKeywordPage(params) {
  return request.post('/ads/adsSbNegativeKeywords/page', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function updateSbAdNegKeyword(params) {
  return request
    .post('/ads/adsSbNegativeKeywords/updateAdsSbNegativeKeywords', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

/** 展示广告 */

export function getSdAdCampaignPage(params) {
  return request.post('/ads/adsSdCampaigns/page', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function updateSdAdCampaign(params) {
  return request
    .put('/ads/adsSdCampaigns/updateAdsSdCampaigns', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getSdAdGroupPage(params) {
  return request.post('/ads/adsSdGroups/page', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function updateSdAdGroup(params) {
  return request
    .put('/ads/adsSdGroups/updateAdsSdGroups', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getSdAdProductPage(params) {
  return request.post('/ads/adsSdProduct/page', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function updateSdAdProduct(params) {
  return request
    .put('/ads/adsSdProduct/updateAdsSdProduct', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getSdAdProductTargetPage(params) {
  return request.post('/ads/adsSdTargeting/page', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function updateSdAdProductTarget(params) {
  return request
    .put('/ads/adsSdTargeting/updateAdsSdTargeting', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getSdAdNegTargetPage(params) {
  return request
    .post('/ads/adsSdNegativeTargeting/page', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function updateSdAdNegTarget(params) {
  return request
    .put('/ads/adsSdNegativeTargeting/updateAdsSdNegativeTargeting', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getSdAdCampaignList(params) {
  return request
    .get('/ads/adsSdCampaigns/getSdCampaignList', { params })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getSdAdGroupList(params) {
  return request
    .get('/ads/adsSdGroups/getSdGroupList', { params })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function addSdAdNegTarget(params) {
  return request.post('/ads/adsSdNegativeTargeting', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function addSdAdProductTarget(params) {
  return request.post('/ads/adsSdTargeting', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function getSdAdProductTargetProduct(params) {
  return request
    .post('/ads/adsSpProductTargeting/getProductRecommendations', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function addSdAdProduct(params) {
  return request.post('/ads/adsSdProduct', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function addSdAdCampaign(params) {
  return request
    .post('/ads/adsSdCampaigns/createAdsSdCampaigns', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

// 广告分析--关键词分析

export function getAdsKeywordPerformancePage(params) {
  return request.post('/ads/adsKeywordPerformance/page', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function getAdsKeywordPerformanceKeyword(params) {
  return request
    .get('/ads/adsKeywordPerformance/keyword', { params })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getAdsKeywordPerformanceAsin(params) {
  return request.post('/ads/adsKeywordPerformance/asin', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

// 广告分析--搜索词分析

export function getAdsSearchKeywordPerformancePage(params) {
  return request
    .post('/ads/adsSearchKeywordPerformance/page', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getAdsSearchKeywordPerformanceSearchKeyword(params) {
  return request
    .get('/ads/adsSearchKeywordPerformance/searchKeyword', { params })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getAdsSearchKeywordPerformanceAsin(params) {
  return request
    .post('/ads/adsSearchKeywordPerformance/asin', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

// 广告分析 - ASIN分析

export function getAdsAsinPerformancePage(params) {
  return request.post('/ads/adsAsinPerformance/page', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function getAdsAsinPerformanceMsku(params) {
  return request.get('/ads/adsAsinPerformance/msku', { params }).then((res) => {
    return Promise.resolve(res.data);
  });
}

//

export function getAdsAsinPerformanceKeyword(params) {
  return request.post('/ads/adsAsinPerformance/keyword', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function getAdsAsinPerformanceTargetingType(params) {
  return request
    .get('/ads/adsAsinPerformance/targetingType', { params })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getAdsAsinPerformanceTargeting(params) {
  return request
    .post('/ads/adsAsinPerformance/targeting', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getAdsAsinPerformancePlacement(params) {
  return request
    .get('/ads/adsAsinPerformance/placement', { params })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getAdsAsinPerformancePlacementItems(params) {
  return request
    .get('/ads/adsAsinPerformance/placement/details', { params })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

// 广告策略

export function getAdsAdjustStrategyTplPage(params) {
  return request.post('/ads/adsStrategyTemplate/page', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function getAdsAdjustStrategyTplList(params) {
  return request.get('/ads/adsStrategyTemplate/templateBox').then((res) => {
    return Promise.resolve(res.data);
  });
}

export function getAdsAdjustStrategyTplLogPage(params) {
  return request
    .post('/ads/adsStrategyTemplateLog/page', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function deleteAdsAdjustStrategyTpl(id) {
  return request
    .delete(`/ads/adsStrategyTemplate/deleteTemplate?id=${id}`)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function deleteAdsAdjustStrategy(params) {
  // return request.post('/ads/adsAsinPerformance/targeting', params)
  //   .then((res) => {
  //     return Promise.resolve(res.data);
  //   });
  return new Promise((resolve) => {
    setTimeout(() => resolve(), 500);
  });
}

export function addAdsAdjustStrategyTpl(params) {
  return request
    .post('/ads/adsStrategyTemplate/createTemplate', params)
    .then((res) => {
      return Promise.resolve(res);
    });
}

export function updateAdsAdjustStrategyTpl(params) {
  return request
    .put('/ads/adsStrategyTemplate/updateTemplate', params)
    .then((res) => {
      return Promise.resolve(res);
    });
}

export function getAdsAdjustStrategyTplById(id) {
  return request
    .get(`/ads/adsStrategyTemplate/templateInfo?templateId=${id}`)
    .then((res) => {
      return Promise.resolve(res);
    });
}

export function getAdsStrategyObjectInfoById(objectId) {
  return request
    .get(`/ads/adsStrategyObject/objectInfo?objectId=${objectId}`)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getAdsAdjustStrategyLog(params) {
  return request.post('/ads/adsStrategyObjectLog/page', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function getAdsAdjustStrategyUsePage(params) {
  return request.post('/ads/adsStrategyObject/page', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function updateAdsAdjustStrategyObject(params) {
  return request
    .put('/ads/adsStrategyObject/updateStrategyObject', params)
    .then((res) => {
      return Promise.resolve(res);
    });
}

export function updateAdsAdjustStrategyObjectStatus(params) {
  return request
    .put('/ads/adsStrategyObject/updateStrategyObjectStatus', params)
    .then((res) => {
      return Promise.resolve(res);
    });
}

export function addAdsAdjustStrategy(params) {
  return request
    .post('/ads/adsStrategyObject/createStrategyObject', params)
    .then((res) => {
      return Promise.resolve(res);
    });
}

// 分时策略-判断是否需要还原-策略
export function getStrategyResumeCondition(params) {
  return request
    .post('/ads/adsStrategyObject/getStrategyResumeCondition', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

// 分时策略-判断是否需要还原-策略-1.10.0
export function getResumeCondition(params) {
  return request
    .post('/ads/adsStrategyObject/getResumeCondition', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

// 开始执行还原 -1.10.0
export function beginResume(params) {
  return request
    .post('/ads/adsStrategyObject/beginResume', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

// 批量修改(移除)广告策略状态
export function batchUpdateStrategyObject(params) {
  return request
    .put('/ads/adsStrategyObject/batchUpdateStrategyObject', params)
    .then((res) => {
      // 不返回至data级的原因,页面成功需要code判断展示报错信息
      return Promise.resolve(res);
    });
}

// 分时策略-判断是否需要还原-模板
export function getTemplateResumeCondition(params) {
  return request
    .post('/ads/adsStrategyObject/getTemplateResumeCondition', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function batchAddAdsAdjustStrategy(params) {
  return request
    .post('/ads/adsStrategyObject/bathCreateStrategyObject', params)
    .then((res) => {
      return Promise.resolve(res);
    });
}

// 广告策略使用模板分页查询

export function getAdsAdjustStrategyCampaignUsePage(params) {
  return request
    .post('/ads/adsSpCampaigns/showStrategyPage', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getAdsAdjustStrategyGroupUsePage(params) {
  return request
    .post('/ads/adsSpGroups/showStrategyPage', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getAdsAdjustStrategyKeywordUsePage(params) {
  return request
    .post('/ads/adsSpKeywords/showStrategyPage', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getAdsAdjustStrategyProductTargetUsePage(params) {
  return request
    .post('/ads/adsSpProductTargeting/showStrategyPage', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getAdsAdjustStrategyPlacementUsePage(params) {
  return request
    .post('/ads/adsSpCampaigns/showPlacementStrategyPage', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getSpAdCampaignStrategyList(params) {
  return request
    .get('/ads/adsSpCampaigns/getCampaignListForStrategy', { params })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getSpAdGroupStrategyList(params) {
  return request
    .get('/ads/adsSpGroups/getGroupListForStrategy', { params })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

/** 关键词排名 */

export function getAdKeywordRankPage(params) {
  return request.post('/ads/keywordRank/page', params).then((res) => {
    return Promise.resolve(res.data);
  });
}

export function getAdsLocationGroup(id) {
  return request
    .get(`/ads/keywordRank/getAdsLocationGroup?id=${id}`)
    .then((res) => res.data);
}

export function addAdKeywordRank(params) {
  return request.post('/ads/keywordRank', params);
}

export function updateAdKeywordRank(params) {
  return request.put('/ads/keywordRank', params);
}

export function deleteAdKeywordRank(id) {
  return request.delete(`/ads/keywordRank?id=${id}`);
}

export function getAdsKeywordQuantity() {
  return request.get('/ads/keywordRank/getAdsKeywordQuantity').then((res) => {
    return Promise.resolve(res.data);
  });
}

export function getAdsRankDynamic(params) {
  return request
    .get('/ads/keywordRank/queryAdsLocationDynamicNew', { params })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getAdsRankDistribution(params) {
  return request
    .get('/ads/keywordRank/queryAdsLocationDistribution', { params })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getAdsRankTrend(params) {
  return request
    .get('/ads/keywordRank/queryAdsLocationTrend', { params })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function updateAdKeywordRankMemo(params) {
  return request.post('/ads/keywordRank/updateMemo', params);
}

/**
 * 品牌广告
 */
//  品牌广告-是否有品牌是否有数据
export function SBDisplay(params) {
  return request.get('/ads/adsSbBasicData/display', { params });
}
//  品牌广告-获取产品品牌信息
export function listProductBrand(params) {
  return request.get('/ads/adsSbBasicData/listProductBrand', { params });
}
// 品牌广告-查询广告活动根据状态分组
export function campaignGrouping(params) {
  return request.get(`/ads/adsSbBasicData/campaignGrouping`, { params });
}
// 品牌广告-广告活动下拉列表
export function spinnerSbCampaign(params) {
  return request.post(`/ads/adsSbCampaigns/spinnerSbCampaign`, params);
}
// 品牌广告-获取广告角标
export function getBrandAdvertisingCornerMark(params) {
  return request.get(`/ads/adsCornerMark/getCornerMark`, { params });
}
// 品牌广告-建议关键词及其竞价
export function suggestedBid(params) {
  return request.post(`/ads/adsSbKeywords/suggestedBid`, params);
}
// 品牌广告-Excel导入关键词
export function importKeywords(params) {
  return request.post(`/ads/adsSbKeywords/importKeywords`, params);
}
// 品牌广告-商品投放分页查询
export function adsSbProductTargetingPage(params) {
  return request.post(`/ads/adsSbProductTargeting/page`, params);
}
// 品牌广告-否定商品投放分页查询
export function adsSbNegativeProductTargetingPage(params) {
  return request.post(`/ads/adsSbNegativeProductTargeting/page`, params);
}
// 品牌广告-新增商品投放获取建议ASIN
export function getRecommendedASIN(params) {
  return request.post(`/ads/adsSbProductTargeting/getRecommendedASIN`, params);
}
// 品牌广告-获取建议分类
export function getSuggestedClassification(params) {
  return request.post(
    `/ads/adsSbProductTargeting/getSuggestedClassification`,
    params
  );
}
// 品牌广告-获取排除品牌
export function getProductBrand(params) {
  return request.get(`/ads/adsSbTargeting/getProductBrand`, { params });
}
// 品牌广告-获取排除品牌
export function getLandingPage(params) {
  return request.get(`/ads/adsSbBasicData/getLandingPage`, { params });
}
// 品牌广告-获取店铺站点信息下拉列表
export function listMarkets(params) {
  return request.get(`/ads/adsSbBasicData/listMarkets`, { params });
}
// 品牌广告-上传图片接口（只支持品牌logo）
export function uploadImage(params) {
  return request.post(`/ads/adsSbAsset/uploadImage`, params);
}
// 品牌广告-获取品牌具体某个图片信息（只支持品牌logo）
export function getAsset(params) {
  return request.get(`/ads/adsSbAsset/getAsset`, { params });
}
// 品牌广告-创建关键词
export function createAdsSbKeywords(params) {
  return request.post(`/ads/adsSbKeywords/createAdsSbKeywords`, params);
}
// 品牌广告-创建否定关键词
export function createAdsSbNegativeKeywords(params) {
  return request.post(
    `/ads/adsSbNegativeKeywords/createAdsSbNegativeKeywords`,
    params
  );
}
// 品牌广告-新增商品投放
export function adsSbProductTargetingCreate(params) {
  return request.post(`/ads/adsSbProductTargeting/create`, params);
}
// 品牌广告-新增否定商品投放
export function adsSbNegativeProductTargetingCreate(params) {
  return request.post(`/ads/adsSbNegativeProductTargeting/create`, params);
}
// 品牌广告-上传视频接口
export function uploadVideo(params) {
  return request.post(`/ads/adsSbMedia/uploadVideo`, params);
}
// 品牌广告-轮询视频上传结果接口
export function pollingDescribe(params) {
  return request.get(`/ads/adsSbMedia/pollingDescribe`, { params });
}
// 品牌广告-活动详情
export function campaignInfo(params) {
  return request.get(`/ads/adsSbCampaigns/campaignInfo`, { params });
}
// 品牌广告-查询站点下的商品
export function productsUnderTheMarket(params) {
  return request.post(
    `/ads/adsSbBasicData/productsUnderTheMarket?marketId=${params.marketId}`,
    params
  );
}
// 品牌广告-着陆页上传ASIN解析
export function uploadAnalysisAsin(params) {
  return request.post(`/ads/adsSbBasicData/uploadAnalysisAsin`, params);
}
// 品牌广告-保存广告活动/广告活动草稿
export function saveAdsSbCampaigns(params) {
  return request.post(`/ads/adsSbCampaigns/saveAdsSbCampaigns`, params);
}
// 品牌广告-编辑广告活动草稿
export function updateAdsSbDraftsCampaigns(params) {
  return request.post(`/ads/adsSbCampaigns/updateAdsSbDraftsCampaigns`, params);
}
// 品牌广告-广告活动草稿提交审核
export function submitAdsDraftsCampaigns(params) {
  return request.post(`/ads/adsSbCampaigns/submitAdsDraftsCampaigns`, params);
}
// 品牌广告-广告活动草稿提交审核
export function getAsinAccordingToUrl(params) {
  return request.post(`/ads/adsSbBasicData/getAsinAccordingToUrl`, params);
}
// 品牌广告-修改商品投放
export function adsSbProductTargetingUpdate(params) {
  return request.post(`/ads//adsSbProductTargeting/update`, params);
}
// 品牌广告-修改否定商品投放
export function adsSbNegativeProductTargetingUpdate(params) {
  return request.post(`/ads/adsSbNegativeProductTargeting/update`, params);
}
// 品牌广告-根据建议分类id获取建议brand
export function getSuggestedBrand(params) {
  return request.post(`/ads/adsSbProductTargeting/getSuggestedBrand`, params);
}
// 品牌广告-获取【品牌缓存log】
export function getLogCacheByBrandEntityId(params) {
  return request.get(`/ads/adsSbCampaigns/getLogCacheByBrandEntityId`, {
    params,
  });
}

// 品牌广告-【出价建议】-出价
export function adsSbBasicDataBids(params) {
  return request.post(`/ads/adsSbBasicData/bids`, params);
}
// 商品广告-【商品投放】-获取建议竞价
export function getAdsSpProductTargetingSuggestedBid(params) {
  return request.post(
    `/ads/adsSpProductTargeting/getAdsSpProductTargetingSuggestedBid`,
    params
  );
}
// 商品广告【关键词】建议竞价，新增关键词
export function getBidRecommendations(params) {
  return request.post(`/ads/adsSpKeywords/getBidRecommendations`, params);
}

// 商品广告【关键词】建议竞价，列表刷新按钮
export function getBidRecommendationsWithTargets(params) {
  return request.post(
    `/ads/adsSpKeywords/getBidRecommendationsWithTargets`,
    params
  );
}

// 商品广告-【关键字】-根据groupId获取建议关键词及竞价
export function getSuggestedKeywordsForGroupId(params) {
  return request.post(
    `/ads/adsSpKeywords/getSuggestedKeywordsForGroupId`,
    params
  );
}

// 展示广告-【其他】-根据状态分组活动
export function adSdCampaignGrouping(params) {
  return request.get(`/ads/adsSdBasicData/campaignGrouping`, { params });
}

// 商品广告-【其他】-根据状态分组广告活动
export function adSpCampaignGrouping(params) {
  return request.get(`/ads/navigationBar/sp`, { params });
}

// 商品广告-【其他】-查询广告组合
export function portfolioGroupingByStatus(params) {
  return request.get(
    `/ads/adsSpBasicData/portfolioGroupingByStatus?marketId=${params}`
  );
}

// 获取广告组建议竞价(仅支持自动投放)
export function getAdsSpGroupSuggestedBid(params) {
  return request.post(`/ads/adsSpGroups/getAdsSpGroupSuggestedBid`, params);
}
// 广告组应用建议竞价
export function updateAdsSpGroupsNew(params) {
  return request.put(`/ads/adsSpGroups/updateAdsSpGroupsNew`, params);
}

// 商品广告 -- 广告活动、广告组、关键词 -- 新建弹框 -- 获取建议关键词列表
export function rankRecommendation(params) {
  return request.post(`/ads/suggest/sp/keywords/rankRecommendation`, params);
}

// 模板规则
export function getTemplateRuleData(params) {
  return request.post(`/ads/autoRule/template/page`, params);
}

// 新增模板规则
export function addTemplate(params) {
  return request.post(`/ads/autoRule/template`, params);
}

// 自动化对象分页查询
export function autoObject(params) {
  return request.post('/ads/autoRule/object/page', params);
}

// 自动化模板日志分页查询
export function getRuleLogData(params) {
  return request.post(`/ads/autoRule/template/log/page`, params);
}

// 查询商品广告——广告活动
export function queryCampaigns(data) {
  return request.post('/ads/select/sp/campaigns', data).then((res) => res.data);
}

// 查询商品广告——广告组
export function queryGroups(data) {
  return request.post('/ads/select/sp/groups', data).then((res) => res.data);
}

// 自动化模板批量创建
export function addRuleTemplate(data) {
  return request.post('/ads/autoRule/template', data).then((res) => res.data);
}

// 查询应用对象规则详情
export function queryRuleDetail(data) {
  return request.post('/ads/autoRule/object/queryRuleDetail', data).then((res) => res.data);
}

// 自动化规则应用到商品广告广告活动分页查询
export function getAutoRuleCampaignData(params) {
  return request.post(`/ads/autoRule/object/sp/campaign`, params).then(res => res.data);
}

// 自动化规则应用到商品广告广告组分页查询
export function getAutoRuleGroupData(params) {
  return request.post(`/ads/autoRule/object/sp/group`, params).then(res => res.data);
}

// 查询相似规则
export function getSameRuleData(params) {
  return request.post(`/ads/autoRule/object/sameRule`, params).then(res => res.data);
}

// 自动化对象批量创建
export function autoRuleObjectData(params) {
  return request.post(`/ads/autoRule/object`, params);
}

// 自动化模板应用详情分页查询
export function getTemplateApplyPageData(params) {
  return request.post(`/ads/autoRule/object/templateApplyPage`, params).then(res => res.data);
}

// 自动化对象日志分页查询
export function getAutoRuleObjectLogPageData(params) {
  return request.post(`/ads/autoRule/object/log/page`, params).then(res => res.data);
}
// 自动化对象批量修改
export function batchRule(data) {
  return request.put('/ads/autoRule/object', data);
}

// 修改模板规则
export function editRuleTemplate(params) {
  return request.put(`/ads/autoRule/template`, params);
}

// 查询模板详情
export function queryTemplate(id) {
  return request.get(`/ads/autoRule/template/${id}`).then(res => res.data);
}

// 修改自动化模板
export function editBatchTemplate(data) {
  return request.put('/ads/autoRule/template', data)
}

// 自动化模板下拉列表
export function templateSelect(data) {
  return request.post('/ads/autoRule/template/templateSelect', data).then(res => res.data);
}

// 查询相似规则
export function querySameRule(data) {
  return request.post('/ads/autoRule/object/sameRule', data).then(res => res.data);
}

// 查询重复name
export function queryCheckName(params) {
  return request.get('/ads/autoRule/template/checkName', {params}).then(res => res.data);
}

// 查询asin info
export function queryAsinInfo(data) {
  return request.post('/ads/asin/info', data).then(res => res.data);
}